<template>
  <div v-if="certifications" class="certifications-list">
    <h1 class="certifications-list__title">Certifications</h1>
    <div class="certifications-list__intro">
      Demonstrate mastery by acing one of these industry leading certifications, and take your
      career to the next level.
    </div>
    <div class="certifications-list__items">
      <CertificationListItem
        v-for="certification in availableCertifications"
        :key="certification.merchant_id"
        :certification="certification"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CertificationListItem from '@/components/certifications/CertificationListItem.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'CertificationsList',
  components: { CertificationListItem },
  computed: {
    ...mapState({
      userHasSubscription: state => state.subscriptions.userHasSubscription,
      availablePlans: state => state.products.availablePlans,
      certifications: state => state.products.availableCertifications,
      isEDAPremiumPreSaleActive: state => state.app.isEDAPremiumPreSaleActive,
    }),
    ...mapGetters({
      selectedPlan: 'shoppingCart/selectedPlan',
    }),
    availableCertifications() {
      const {
        VOUCHERS: { EDA },
      } = CONSTANTS
      let certificationsList = this.certifications
      if (this.isEDAPremiumPreSaleActive) {
        certificationsList = certificationsList.filter(cert => cert.merchant_id !== EDA)
      }
      return certificationsList
    },
  },
}
</script>

<style lang="scss" scoped>
.certifications-list {
  &__intro {
    color: var(--light-blue-gray);
    font-size: rem(18px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px);
    margin-bottom: 30px;
  }
  &__items {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(1, 1fr);
    @include mobile {
      grid-template-columns: repeat(2, minmax(226px, 1fr));
    }
    @include desktop {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
